import axios from "axios";
let baseDomain = "";
if (process.env.NODE_ENV === "development") {
    baseDomain = window.location.origin;
}
const baseUrl = `${baseDomain}/api`;
const globalAxios = axios.create({ baseURL: baseUrl });
export default globalAxios;
